import axios from 'axios'
import { apiRoot } from "@/helpers/variables";
export default {
  data: function () {
    return {

    }
  },
  methods: {
    dateToFormatWithDots (date) {
      if (date === null) return;
      const t = date.split(/[- :]/);
      const parsedDate = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));

      return ("0" + parsedDate.getDate()).slice(-2) + '.' + ("0" + (parsedDate.getMonth() + 1)).slice(-2) + '.' + parsedDate.getFullYear().toString().substr(-2)
    },
    canAccess (requiredRoles) {
      if (requiredRoles === undefined || requiredRoles.length === 0 || this.$store.state.user.roles.includes('Administrator')) {
        return true
      }

      if (!this.$store.state.isAuthenticated() || !this.$store.state.isTokenActive() || this.$store.state.user === undefined || this.$store.state.user === null || this.$store.state.user.roles === undefined) {
        return false
      }

      if (requiredRoles.filter(value => this.$store.state.user.roles.includes(value)).length > 0) {
        return true
      }

      return false
    },
    // eslint-disable-next-line no-unused-vars
    apiCall (endpoint, method = 'get', params = {}) {
      if (!this.$store.state.isAuthenticated()) {
        console.error('Invalid token')
        return;
      }

      const ret = [];
      for (let d in params)
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(params[d]));

      switch (method.toLowerCase()) {
        case 'post':
          return axios.post(`${apiRoot}${endpoint}`, {
            body: params
          }, {
            withCredentials: false,
            crossdomain: true,
            headers: {
              Authorization: `Bearer ${this.$store.state.user.token}`,
            }
          })
        case 'get':
        default:
          return axios.get(`${apiRoot}${endpoint}` + (ret.length > 0 ? '?' + ret.join('&') : ''), {
            withCredentials: false,
            crossdomain: true,
            headers: {
              Authorization: `Bearer ${this.$store.state.user.token}`,
            }
          })
      }
    },
  }
}
